<template>
  <div class="rl-page">
    <div class="rl-hero-header">
      <section class="rl-hero">
        <AtsHeroBackground
          class="rl-hero__bg"
          :src="assets.heroBg"
          size="100% 100%"
          fallback-color="#0a1628"
        />
        <div class="rl-hero__mask" aria-hidden="true" />
        <div class="rl-hero__inner">
          <div class="rl-hero__content">
            <h1 class="rl-hero__title">救援清单</h1>
            <p class="rl-hero__desc">
              大救星首创“救援+保险”服务清单产品，以清单为载体，助力景区、滑雪场、旅行社等流量密集场景构建“防、保、救、赔、调、流”六位一体旅游安全应急救援保障体系。借助市场化手段帮助客户解决落实保障体系建设的资金及技术方案等。
            </p>
            <p class="rl-hero__desc rl-hero__desc--second">
              目前已为国内上百家景区、滑雪场、旅行社提供服务，获得广泛好评。
            </p>
      </div>  
    </div> 
      </section>
            </div>
          
    <!-- 救援/救治/救助/救护 服务清单（四栏） -->
    <section class="rl-section rl-section--services" aria-label="服务清单">
      <ul class="rl-services">
        <li
          v-for="(card, index) in serviceCards"
          :key="card.title"
          class="rl-services__item"
          :class="{ 'rl-services__item--active': card.highlight }"
          :style="serviceCardStyle(card)"
        >
          <div class="rl-services__body">
            <span class="rl-services__icon-wrap">
              <img
                class="rl-services__icon"
                :src="card.icon"
                alt=""
                role="presentation"
                width="40"
                height="40"
                decoding="async"
              >
            </span>
            <h3 class="rl-services__title">{{ card.title }}</h3>
            <ul class="rl-services__list">
              <li
                v-for="item in serviceListItems"
                :key="`${card.title}-${item}`"
                class="rl-services__list-item"
              >
                {{ item }}
          </li>
        </ul>
            <img
              class="rl-services__rule"
              :src="card.ruleImg"
              alt=""
              role="presentation"
              decoding="async"
            >
            <p class="rl-services__index">
              <span class="rl-services__index-current">{{ String(index + 1).padStart(2, '0') }}</span>
              <span class="rl-services__index-total"> / 04</span>
            </p>
          </div>
          </li>
        </ul>
    </section>

    <!-- 商旅 / 出行保障轮播 -->
    <section
      class="rl-section rl-section--travel"
      :style="travelSectionStyle"
      aria-label="商旅与出行保障"
    >
      <div class="rl-travel__shade" aria-hidden="true" />
      <div class="rl-travel__inner">
        <transition name="rl-travel-fade" mode="out-in">
          <div :key="travelSlideIndex" class="rl-travel__content">
            <h2 class="rl-travel__title">{{ currentTravelSlide.title }}</h2>
            <p class="rl-travel__desc">{{ currentTravelSlide.desc }}</p>
            <!-- <span class="rl-travel__rule" aria-hidden="true" /> -->
            </div>
        </transition>
        <ul class="rl-travel__dots" role="tablist" :aria-label="`${currentTravelSlide.title}轮播`">
          <li
            v-for="(slide, i) in travelSlides"
            :key="slide.id"
            class="rl-travel__dot-item"
          >
            <button
              type="button"
              class="rl-travel__dot"
              role="tab"
              :aria-selected="travelSlideIndex === i"
              :aria-label="slide.title"
              :class="{ 'is-active': travelSlideIndex === i }"
              @click="setTravelSlide(i)"
            />
          </li>
        </ul>
            </div>
    </section>

    <!-- 防保救调赔流 · 六位一体（标题在背景区外，六卡在背景区内） -->
    <div class="rl-six" aria-label="六位一体救援服务保障体系">
      <header class="rl-six__head">
        <p class="rl-six__eyebrow">「防保救调赔流」</p>
        <span class="rl-six__head-rule" aria-hidden="true" />
        <h2 class="rl-h2 rl-six__title">六位一体的救援服务保障体系</h2>
      </header>
      <section class="rl-section rl-section--six" :style="sixSectionStyle">
        <ul class="rl-six__grid" :style="sixGridStyle">
          <li
            v-for="(item, index) in sixPillars"
            :key="item.char"
            class="rl-six__card"
            :class="{ 'rl-six__card--active': sixActiveIndex === index }"
            @mouseenter="sixActiveIndex = index"
          >
            <span class="rl-six__char-wrap">
              <span class="rl-six__char">{{ item.char }}</span>
              </span>
            <h3 class="rl-six__card-title">{{ item.title }}</h3>
            <p class="rl-six__card-desc">{{ item.desc }}</p>
            <span class="rl-six__card-rule" aria-hidden="true" />
            </li>
          </ul>
      </section>
           </div>
           
    <!-- 企业服务定制 -->
    <section class="rl-section rl-section--enterprise" aria-label="企业服务定制">
      <h2 class="rl-h2 rl-enterprise__title">企业服务定制</h2>
      <ul class="rl-enterprise">
        <li
          v-for="panel in enterprisePanels"
          :key="panel.title"
          class="rl-enterprise__panel"
        >
          <img
            class="rl-enterprise__bg"
            :src="panel.bg"
            alt=""
            role="presentation"
            loading="lazy"
            decoding="async"
          >
          <div class="rl-enterprise__panel-inner">
            <img
              class="rl-enterprise__icon"
              :src="panel.icon"
              alt=""
              role="presentation"
              decoding="async"
            >
            <h3 class="rl-enterprise__panel-title">{{ panel.title }}</h3>
            <p class="rl-enterprise__panel-desc">{{ panel.desc }}</p>
          </div>
              </li>
            </ul> 
    </section>

    <!-- 守望计划 -->
    <section class="rl-section rl-section--guardian" aria-label="守望计划">
      <img
        class="rl-guardian__bg"
        :src="assets.sectionGuardian"
        alt=""
        role="presentation"
        decoding="async"
      >
      <div class="rl-guardian__inner">
        <div class="rl-guardian__content">
          <img
            class="rl-guardian__watermark"
            :src="assets.textGuardianWatermark"
            alt=""
            role="presentation"
            decoding="async"
          >
          <h2 class="rl-guardian__title">守望计划救援服务</h2>
          <p class="rl-guardian__desc">
            基于救援清单服务，大救星在非洲正式发起“守望计划”，全面聚焦在非中国企业及个人安全风险防范，打造非洲中国救援力量联合体，全方位保障在非中国同胞生命健康。
          </p>
          <button type="button" class="rl-guardian__btn">
            查看详情
            <span class="rl-guardian__btn-arrow" aria-hidden="true">↘</span>
          </button>
          </div>
        </div>
    </section>

    <!-- 平台系统 -->
    <section class="rl-section rl-section--platform" aria-label="平台系统">
      <h2 class="rl-h2 rl-platform__title">平台系统</h2>
      <ul class="rl-platform">
        <li
          v-for="item in platformItems"
          :key="item.title"
          class="rl-platform__card"
          :style="platformCardStyle"
        >
          <span class="rl-platform__icon-wrap">
            <img
              class="rl-platform__icon"
              :src="item.icon"
              alt=""
              role="presentation"
              decoding="async"
            >
          </span>
          <h3 class="rl-platform__card-title">{{ item.title }}</h3>
          <p class="rl-platform__card-sub">{{ item.subtitle }}</p>
          <img
            class="rl-platform__arrow"
            :src="assets.iconArrowDiagonal"
            alt=""
            role="presentation"
            width="30"
            height="10"
            decoding="async"
          >
          </li>
        </ul>
    </section>

    <AtsSiteFooter />
  </div>
</template>

<script>
import AtsSiteFooter from '@/components/ats/AtsSiteFooter.vue'
import AtsHeroBackground from '@/components/ats/AtsHeroBackground.vue'

/**
 * 救援清单专题页：素材来自 `src/assets/rescuelist`（英文命名）
 */
export default {
  name: 'RescueListPage',
  components: {
    AtsSiteFooter,
    AtsHeroBackground
  },
  data () {
    return {
      /** @type {number} 商旅轮播当前下标 */
      travelSlideIndex: 0,
      /** @type {number} 六位一体当前高亮卡下标（默认「保」） */
      sixActiveIndex: 1,
      assets: {
        heroBg: require('@/assets/rescuelist/hero_bg_city_night.png'),
        cardFeatureActiveBg: require('@/assets/rescuelist/card_feature_active_bg.png'),
        cardFeatureBg01: require('@/assets/rescuelist/card_feature_bg_01.png'),
        uiSpacer1px: require('@/assets/rescuelist/ui_spacer_1px.png'),
        uiSpacer1pxAlt: require('@/assets/rescuelist/ui_spacer_1px_alt.png'),
        iconRescueSystem: require('@/assets/rescuelist/icon_feature_rescue_system.png'),
        iconIntegrated: require('@/assets/rescuelist/icon_feature_integrated_service.png'),
        iconServiceSystem: require('@/assets/rescuelist/icon_feature_service_system.png'),
        iconCustomer: require('@/assets/rescuelist/icon_feature_customer_service.png'),
        sectionAirplane: require('@/assets/rescuelist/section_emergency_airplane_bg.png'),
        /** 商旅轮播首屏背景（设计稿飞机图，可与 section_emergency_airplane_bg 同源） */
        sectionBusinessTravel: require('@/assets/rescuelist/section_emergency_airplane_bg.png'),
        sectionSixBg: require('@/assets/rescuelist/section_six_in_one_bg.png'),
        sectionPlatformBg: require('@/assets/rescuelist/section_platform_system_bg.png'),
        panelClimbing: require('@/assets/rescuelist/panel_enterprise_climbing.png'),
        panelAmusement: require('@/assets/rescuelist/panel_enterprise_amusement.png'),
        panelSki: require('@/assets/rescuelist/panel_enterprise_ski.png'),
        panelResort: require('@/assets/rescuelist/panel_enterprise_resort.png'),
        sectionGuardian: require('@/assets/rescuelist/section_guardian_plan_bg.png'),
        textGuardianWatermark: require('@/assets/rescuelist/text_guardian_plan_watermark.png'),
        iconPlatformProduct: require('@/assets/rescuelist/icon_platform_health.png'),
        iconPlatformRescue: require('@/assets/rescuelist/icon_platform_global_rescue.png'),
        iconPlatformHealth: require('@/assets/rescuelist/icon_platform_health.png'),
        iconPlatformGlobal: require('@/assets/rescuelist/icon_platform_global_rescue.png'),
        iconEnterpriseFlag: require('@/assets/rescuelist/icon_enterprise_flag.png'),
        iconEnterpriseSki: require('@/assets/rescuelist/icon_enterprise_ski_boot.png'),
        iconEnterpriseRing: require('@/assets/rescuelist/icon_platform_ring.png'),
        iconEnterpriseMountain: require('@/assets/rescuelist/icon_platform_smart_product.png'),
        uiChipLearnMore: require('@/assets/rescuelist/ui_chip_learn_more.png'),
        iconArrowRightSmall: require('@/assets/rescuelist/icon_arrow_right_small.png'),
        iconArrowDiagonal: require('@/assets/rescuelist/icon_arrow_diagonal_white.png'),
        uiDotActive: require('@/assets/rescuelist/ui_dot_active.png'),
        uiDotInactive: require('@/assets/rescuelist/ui_dot_inactive.png')
      }
    }
  },
  computed: {
    /**
     * 服务四栏卡片（静态展示，第 2 栏为设计稿高亮态）
     * @returns {Array<{ title: string, icon: string, ruleImg: string, highlight: boolean, activeBg: string|null }>}
     */
    serviceCards () {
      const a = this.assets
      return [
        { title: '救援服务', icon: a.iconCustomer, ruleImg: a.uiSpacer1pxAlt, highlight: false, activeBg: null },
        { title: '救治服务', icon: a.iconServiceSystem, ruleImg: a.uiSpacer1px, highlight: true, activeBg: a.cardFeatureActiveBg },
        { title: '救助服务', icon: a.iconIntegrated, ruleImg: a.uiSpacer1pxAlt, highlight: false, activeBg: null },
        { title: '救护服务', icon: a.iconRescueSystem, ruleImg: a.uiSpacer1pxAlt, highlight: false, activeBg: null }
      ]
    },
    /**
     * 各栏共用服务条目（双列栅格，从左到右、从上到下排列）
     * @returns {string[]}
     */
    serviceListItems () {
      return [
        '住院加急安排',
        '手术加急安排',
        '电话医生',
        '普通/专家门诊绿通',
        '境内外体检安排',
        '二次诊疗',
        '陪诊服务',
        '多学科专家会诊'
      ]
    },
    /**
     * 商旅等出行保障轮播条目
     * @returns {Array<{ id: string, title: string, desc: string, bg: string }>}
     */
    travelSlides () {
      const a = this.assets
      return [
        {
          id: 'business',
          title: '商旅',
          desc:
            '面向商务出行与旅游人群，提供医疗救援、救助及保险一站式服务，覆盖紧急医疗转运、费用担保垫付及星使陪同就医，确保安心旅程。',
          bg: a.sectionBusinessTravel
        },
        {
          id: 'emergency',
          title: '应急',
          desc:
            '覆盖出行前风险评估、行程中实时监测与突发事件的快速响应调度，形成可落地的应急救援闭环，为机构与个人提供可量化、可追踪的保障能力。',
          bg: a.sectionAirplane
        },
        {
          id: 'rescue',
          title: '救援',
          desc:
            '全球救援网络联动，提供紧急医疗转运、送返及现场协调，为出境商旅与机构客户构建可触达、可执行的救援保障能力。',
          bg: a.sectionAirplane
        },
        {
          id: 'aid',
          title: '救助',
          desc:
            '围绕出行场景提供电话医生、门诊绿通、陪诊与多学科会诊等救助服务，让商务与休闲旅程中的健康需求得到及时响应。',
          bg: a.sectionAirplane
        }
      ]
    },
    /**
     * 当前商旅轮播项
     * @returns {{ id: string, title: string, desc: string, bg: string }}
     */
    currentTravelSlide () {
      return this.travelSlides[this.travelSlideIndex] || this.travelSlides[0]
    },
    /**
     * 商旅轮播区背景
     * @returns {{ backgroundImage: string, backgroundSize: string, backgroundPosition: string, backgroundRepeat: string }}
     */
    travelSectionStyle () {
      const slide = this.currentTravelSlide
      return {
        backgroundImage: `url(${slide.bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center right',
        backgroundRepeat: 'no-repeat'
      }
    },
    /**
     * 六位一体区块外层背景（section_six_in_one_bg）
     * @returns {{ backgroundColor: string, backgroundImage: string, backgroundSize: string, backgroundPosition: string, backgroundRepeat: string }}
     */
    sixSectionStyle () {
      return {
        backgroundColor: '#f4f9fc',
        backgroundImage: `url(${this.assets.sectionSixBg})`,
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
    },
    /**
     * 六位一体六卡容器背景（section_platform_system_bg）
     * @returns {{ backgroundImage: string, backgroundSize: string, backgroundPosition: string, backgroundRepeat: string }}
     */
    sixGridStyle () {
      return {
        backgroundImage: `url(${this.assets.sectionPlatformBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
    },
    /**
     * 六位一体六卡
     * @returns {Array<{ char: string, title: string, desc: string, active?: boolean }>}
     */
    sixPillars () {
      const desc =
        '依托专业风控团队、全球救援智能云平台与资深风险管理经验，提供风险识别排查应急预案定制。'
      return [
        { char: '防', title: '风险预防', desc },
        { char: '保', title: '保险保障', desc },
        { char: '救', title: '应急救援', desc },
        { char: '调', title: '纠纷调解', desc },
        { char: '赔', title: '事故赔偿', desc },
        { char: '流', title: '客源引流', desc }
      ]
    },
    /**
     * 企业服务定制四栏
     * @returns {Array<{ title: string, desc: string, bg: string, icon: string }>}
     */
    enterprisePanels () {
      const a = this.assets
      return [
        {
          title: '景区',
          desc: '针对景区大客流、全域游览场景定制专属方案',
          bg: a.panelClimbing,
          icon: a.iconEnterpriseMountain
        },
        {
          title: '游乐场',
          desc: '针对游乐场特种设备密集、亲子客群集中等特点定制专属方案',
          bg: a.panelAmusement,
          icon: a.iconPlatformRescue
        },
        {
          title: '滑雪场',
          desc: '针对冰雪运动高风险场景定制专属方案',
          bg: a.panelSki,
          icon: a.iconEnterpriseSki
        },
        {
          title: '旅行社',
          desc: '针对旅行社境内外组团全场景定制专属方案',
          bg: a.panelResort,
          icon: a.iconEnterpriseFlag
        }
      ]
    },
    /**
     * 平台系统四卡
     * @returns {Array<{ title: string, subtitle: string, icon: string }>}
     */
    platformItems () {
      const a = this.assets
      return [
        { title: '智能产品', subtitle: '产品介绍', icon: a.iconPlatformProduct },
        { title: '智能救援', subtitle: '产品介绍', icon: a.iconPlatformRescue },
        { title: '健康管理', subtitle: '产品介绍', icon: a.iconPlatformHealth },
        { title: '全球救援', subtitle: '产品介绍', icon: a.iconPlatformGlobal }
      ]
    },
    /**
     * 平台系统卡片背景（330×470，铺满 card_feature_bg_01）
     * @returns {{ width: string, height: string, backgroundImage: string, backgroundSize: string, backgroundPosition: string, backgroundRepeat: string }}
     */
    platformCardStyle () {
      return {
        width: '330px',
        height: '470px',
        backgroundImage: `url(${this.assets.cardFeatureBg01})`,
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
    },
    /**
     * 了解更多按钮背景
     * @returns {{ backgroundImage: string, backgroundSize: string, backgroundRepeat: string, backgroundPosition: string }}
     */
    learnMoreBtnStyle () {
      return {
        backgroundImage: `url(${this.assets.uiChipLearnMore})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }
    }
  },
  methods: {
    /**
     * @param {{ id: string }} item
     * @returns {void}
     */
    /**
     * 服务栏背景（仅高亮栏使用医疗底图）
     * @param {{ highlight: boolean, activeBg: string|null }} card
     * @returns {{ backgroundColor?: string, backgroundImage?: string, backgroundSize?: string, backgroundPosition?: string, backgroundRepeat?: string }}
     */
    serviceCardStyle (card) {
      if (!card.highlight || !card.activeBg) {
        return { backgroundColor: '#ffffff' }
      }
      return {
        backgroundColor: 'transparent',
        backgroundImage: `url(${card.activeBg})`,
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
    },
    /**
     * 切换商旅轮播
     * @param {number} index
     * @returns {void}
     */
    setTravelSlide (index) {
      this.travelSlideIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../components/ats/mixins';
$green: #256a30;
$text-dark: #1a2226;

.rl-page {
  min-height: 100vh;
  background: #ffffff;
  color: $text-dark;
  font-family: 'Microsoft YaHei', 'PingFang SC', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
}

.rl-hero-header {
  position: relative;
  height: 871px;
  min-height: 871px;
  max-height: 871px;
}

.rl-hero {
  position: relative;
  height: 100%;
  min-height: 871px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #fff;
  overflow: hidden;
}

.rl-hero__bg {
  background-size: 100% 100%;
  background-position: center;
}

/** 轻遮罩：仅略微压暗，保证白字可读（已移除 hero_overlay_gradient 叠层） */
.rl-hero__mask {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.06) 0%,
    rgba(0, 0, 0, 0) 42%,
    rgba(0, 0, 0, 0.12) 100%
  );
  pointer-events: none;
}

/** 与 `AtsSiteNav` 的 `.ats-nav__inner` 同宽、同左右 padding，文案左缘与 Logo 对齐 */
.rl-hero__inner {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: flex-start;
  width: 100%;
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 36px;
  box-sizing: border-box;
}

.rl-hero__content {
  width: 100%;
  max-width: 982px;
  text-align: left;
}

.rl-hero__title {
  margin: 0 0 50px;
  font-size: 56px;
  font-weight: 800;
  line-height: 1.22;
  letter-spacing: 0.08em;
  color: #fff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5), 0 4px 28px rgba(0, 0, 0, 0.4);
}

.rl-hero__desc {
  margin: 0;
  font-size: 24px;
  font-weight: 400;
  line-height: 1.75;
  letter-spacing: 0.04em;
  color: #fff;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.45), 0 2px 16px rgba(0, 0, 0, 0.35);
}

.rl-hero__desc--second {
  margin-top: 40px;
}

.rl-section {
  margin: 0 auto;
  padding: 72px max(24px, calc((100% - 1160px) / 2));
  box-sizing: border-box;
}

.rl-h2 {
  margin: 0 0 32px;
  font-size: 42px;
  font-weight: 700;
  line-height: 1.25;
  color: $text-dark;
}

.rl-h2--on-dark {
  color: #ffffff;
}

/* 服务清单四栏 */
.rl-section--services {
  padding: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.rl-services {
  list-style: none;
  margin: 0 auto;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(4, 350px);
  justify-content: center;
  gap: 0;
  width: fit-content;
  max-width: 100%;
}

.rl-services__item {
  position: relative;
  width: 350px;
  height: 600px;
  box-sizing: border-box;
  background: #ffffff;
  background-repeat: no-repeat;
  background-position: center;
  border-right: 1px solid #e8ecef;
  overflow: hidden;
  flex-shrink: 0;
  &:last-child {
    border-right: none;
  }
}

.rl-services__body {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  padding: 48px 36px 40px;
  box-sizing: border-box;
  background: transparent;
}

.rl-services__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-bottom: 28px;
  border-radius: 10px;
  background: rgba(37, 106, 48, 0.1);
}

.rl-services__icon {
  display: block;
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.rl-services__title {
  margin: 0 0 28px;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.3;
  color: $text-dark;
}

.rl-services__list {
  list-style: none;
  margin: 0 0 auto;
  padding: 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px 20px;
}

.rl-services__list-item {
  font-size: 14px;
  line-height: 1.5;
  color: #666666;
  text-align: left;
}

.rl-services__rule {
  display: block;
  width: 64px;
  height: 4px;
  margin: 32px 0 24px;
  object-fit: fill;
  opacity: 0.35;
}

.rl-services__index {
  margin: 0;
  font-size: 16px;
  line-height: 1;
  color: #999999;
  letter-spacing: 0.06em;
}

.rl-services__index-current {
  font-size: 30px;
  font-weight: 300;
  color: #333333;
}

.rl-services__index-total {
  font-size: 18px;
  font-weight: 400;
  color: #bbbbbb;
}

.rl-services__item--active {
  border-right-color: transparent;
  .rl-services__icon-wrap {
    background: rgba(255, 255, 255, 0.14);
  }
  .rl-services__title {
    color: #ffffff;
    text-shadow: 0 1px 8px rgba(0, 0, 0, 0.4);
  }
  .rl-services__list-item {
    color: rgba(255, 255, 255, 0.95);
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);
  }
  .rl-services__rule {
    opacity: 0.55;
    filter: brightness(0) invert(1);
  }
  .rl-services__index-current {
    color: #ffffff;
    font-weight: 400;
  }
  .rl-services__index-total {
    color: rgba(255, 255, 255, 0.65);
  }
}

/* 商旅 / 出行保障轮播 */
.rl-section--travel {
  position: relative;
  height: 700px;
  min-height: 700px;
  padding: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.rl-travel__shade {
    position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(
    90deg,
    rgba(8, 28, 58, 0.82) 0%,
    rgba(8, 28, 58, 0.45) 38%,
    rgba(8, 28, 58, 0.08) 62%,
    transparent 78%
  );
}

.rl-travel__inner {
  position: relative;
  z-index: 2;
    width: 100%;
  max-width: 1320px;
  margin: 0 auto;
  box-sizing: border-box;
}

.rl-travel__content {
  max-width: 640px;
}

.rl-travel__title {
  margin: 0;
  font-size: 50px;
  font-weight: 700;
  line-height: 1.2;
  color: #ffffff;
  letter-spacing: 0.04em;
}

.rl-travel__desc {
  margin: 50px 0 100px;
  max-width: 560px;
  font-size: 22px;
  line-height: 1.85;
  color: rgba(255, 255, 255, 0.92);
}

.rl-travel__rule {
  display: block;
  width: 64px;
  height: 4px;
  margin: 0 0 40px;
  background: #ffffff;
  border-radius: 2px;
}

.rl-travel__dots {
  display: flex;
  align-items: center;
  gap: 10px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.rl-travel__dot-item {
  margin: 0;
  padding: 0;
}

.rl-travel__dot {
  display: block;
  width: 20px;
  height: 4px;
  padding: 0;
  border: none;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.35);
  cursor: pointer;
  transition: width 0.25s ease, background-color 0.25s ease, transform 0.18s ease;

  &:not(.is-active):hover {
    transform: scaleX(1.15);
    background: rgba(255, 255, 255, 0.65);
  }

  &:active:not(.is-active) {
    transform: scaleX(1.05);
  }
}

.rl-travel__dot.is-active {
  width: 32px;
  background: #ffffff;
}

.rl-travel-fade-enter-active,
.rl-travel-fade-leave-active {
  transition: opacity 0.28s ease;
}

.rl-travel-fade-enter,
.rl-travel-fade-leave-to {
  opacity: 0;
}

/* 防保救调赔流 · 六位一体 */
.rl-six {
  background: #ffffff;
}

.rl-six__head {
  margin: 0 auto 60px;
  padding: 120px max(24px, calc((100% - 1160px) / 2)) 0;
  box-sizing: border-box;
    text-align: center;
  }

.rl-section--six {
  margin: 0;
  box-sizing: border-box;
  min-height: 470px;
  padding: 40px max(24px, calc((100% - 1160px) / 2)) 60px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.rl-six__eyebrow {
  margin: 0 0 20px;
  font-size: 30px;
  line-height: 1.5;
  color: #999999;
  letter-spacing: 0.08em;
}

.rl-six__head-rule {
  display: block;
  width: 64px;
  height: 4px;
  margin: 0 auto 28px;
  background: $green;
  border-radius: 2px;
}

.rl-six__title {
  margin: 0;
  font-size: 42px;
  font-weight: 700;
  color: $text-dark;
}

.rl-six__grid {
  list-style: none;
  margin: 0 auto;
  padding: 0;
  width: 1400px;
  max-width: 100%;
  height: 390px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(6, 232px);
  justify-content: center;
  column-gap: calc((1400px - 232px * 6) / 5);
  align-items: stretch;
}

.rl-six__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 232px;
  padding: 24px 14px 20px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 2px;
  box-sizing: border-box;
  height: 100%;
  cursor: default;
  transition: box-shadow 0.25s ease, transform 0.18s ease;

  &:hover {
    box-shadow: 0 8px 28px rgba(15, 35, 52, 0.08);
    transform: translateY(-3px);
  }
}

.rl-six__char-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  margin: 40px 0 0;
  border: 1px dashed rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  transition: border-color 0.25s ease;
}

.rl-six__char {
  font-size: 40px;
  font-weight: 800;
  line-height: 1;
  color: #333333;
  transition: color 0.25s ease;
}

.rl-six__card-title {
  margin: 40px 0 30px;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  color: $text-dark;
  transition: color 0.25s ease;
}

.rl-six__card-desc {
  flex: 1;
  margin: 0;
  font-size: 13px;
  line-height: 1.75;
      color: #666666;
  text-align: left;
}

.rl-six__card-rule {
  display: block;
  width: 64px;
  height: 4px;
  margin-top: auto;
  background: #d8dde3;
  border-radius: 2px;
  transition: background-color 0.25s ease;
}

.rl-six__card--active {
  .rl-six__char-wrap {
    border-color: #1a6fd4;
  }
  .rl-six__char,
  .rl-six__card-title {
    color: #1a6fd4;
  }
  .rl-six__card-rule {
    background: #1a6fd4;
  }
}

/* 企业服务定制（四栏 350×600，对齐设计稿） */
.rl-section--enterprise {
  padding: 88px 0 96px;
  background: #ffffff;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.rl-enterprise__title {
  margin: 0 auto 56px;
  padding: 0 24px;
  text-align: center;
  font-size: 42px;
  font-weight: 700;
  line-height: 1.25;
  color: $text-dark;
}

.rl-enterprise {
  list-style: none;
    margin: 0 auto;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(4, 350px);
  justify-content: center;
  gap: 0;
  width: fit-content;
  max-width: 100%;
    box-sizing: border-box;
}

.rl-enterprise__panel {
  position: relative;
  width: 350px;
  height: 600px;
  box-sizing: border-box;
  overflow: hidden;
  color: #ffffff;
  flex-shrink: 0;
  background: transparent;
}

.rl-enterprise__bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  width: 100%;
    height: 100%;
  object-fit: fill;
  object-position: center;
    display: block;
  pointer-events: none;
}

.rl-enterprise__panel-inner {
  position: relative;
  z-index: 1;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  padding: 0 32px 48px;
  box-sizing: border-box;
  text-align: center;
}

.rl-enterprise__icon {
  flex-shrink: 0;
  width: 53px;
  height: 60px;
  margin: 200px 0 70px;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.rl-enterprise__panel-title {
  margin: 0 0 45px;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: 0.08em;
  color: #ffffff;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
}

.rl-enterprise__panel-desc {
  margin: 0;
  max-width: 286px;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.85;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.94);
  text-align: center;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
}

/* 守望计划（对齐设计稿：全宽山景 + GUARDIAN PLAN 水印 + 左对齐文案） */
.rl-section--guardian {
  position: relative;
    width: 100%;
  height: 600px;
  min-height: 600px;
  padding: 0;
  display: flex;
  align-items: center;
  color: #ffffff;
  overflow: hidden;
  box-sizing: border-box;
}

.rl-guardian__bg {
  position: absolute;
  inset: 0;
  z-index: 0;
    width: 100%;
  height: 100%;
  object-fit: fill;
  object-position: center;
  display: block;
  pointer-events: none;
}

.rl-guardian__inner {
  position: relative;
  z-index: 1;
    display: flex;
  align-items: center;
  width: 100%;
  max-width: 1320px;
  height: 100%;
  margin: 0 auto;
  padding: 0 36px;
  box-sizing: border-box;
}

.rl-guardian__content {
  position: relative;
  z-index: 1;
  max-width: 820px;
  text-align: left;
}

.rl-guardian__watermark {
  display: block;
  width: auto;
  max-width: 100%;
  height: auto;
  margin: 0 0 20px;
  opacity: 0.22;
  pointer-events: none;
}

.rl-guardian__title {
  margin: 0 0 28px;
  font-size: 42px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: 0.06em;
  color: #ffffff;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
}

.rl-guardian__desc {
  margin: 0 0 40px;
  max-width: 780px;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.75;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.94);
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
}

.rl-guardian__btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 32px;
  border: 1px solid #ffffff;
  border-radius: 999px;
  background: transparent;
  font-family: inherit;
  font-size: 16px;
  font-weight: 500;
  line-height: 1;
  color: #ffffff;
  cursor: pointer;
  @include ats-hover-outline;
  &:hover {
    background-color: rgba(255, 255, 255, 0.12);
  }
}

.rl-guardian__btn-arrow {
  font-size: 14px;
  line-height: 1;
}

.rl-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 36px;
  border: none;
  background-color: transparent;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  @include ats-hover-pill(1.05);
}

.rl-btn--light {
  color: #fff;
}

.rl-btn__arrow {
  display: block;
}

/* 平台系统 */
.rl-section--platform {
  padding-top: 80px;
  padding-bottom: 96px;
  background-color: #ffffff;
}

.rl-platform__title {
    text-align: center;
  margin-bottom: 48px;
}

.rl-platform {
  list-style: none;
  margin: 0 auto;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(4, 330px);
  justify-content: center;
  gap: 20px;
  max-width: 1380px;
}

.rl-platform__card {
  position: relative;
  width: 330px;
  height: 470px;
  padding: 40px 28px 36px;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
}

.rl-platform__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  margin: 40px auto 0;
  border-radius: 50%;
}

.rl-platform__icon {
  width: 50px;
  height: 60px;
  object-fit: contain;
}

.rl-platform__card-title {
  margin: 70px 0 20px;
  font-size: 34px;
  font-weight: 700;
  color: #152443;
}

.rl-platform__card-sub {
  margin: 70px 0 16px;
  font-size: 24px;
  color: #152443;
}

.rl-platform__arrow {
  display: block;
  width: 30px;
  height: 10px;
  margin: 0 auto;
  object-fit: contain;
}

@media (max-width: 960px) {
  .rl-hero-header {
    height: auto;
    min-height: 480px;
    max-height: none;
  }
  .rl-hero {
    height: auto;
    min-height: 480px;
    max-height: none;
  }
  .rl-hero__inner {
    padding: 0 20px;
  }
  .rl-hero__desc {
    font-size: 18px;
    line-height: 1.7;
  }
  .rl-hero__desc--second {
    margin-top: 40px;
  }
  .rl-services {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
  }
  .rl-services__item {
    width: 100%;
    height: auto;
    min-height: 520px;
    border-right: none;
    border-bottom: 1px solid #e8ecef;
    &:nth-child(odd) {
      border-right: 1px solid #e8ecef;
    }
    &:last-child {
      border-bottom: none;
    }
  }
  .rl-services__body {
    height: 600px;
    padding: 36px 24px 32px;
  }
  .rl-services__title {
    font-size: 24px;
  }
  .rl-section--six {
    padding: 0 20px 48px;
    overflow: visible;
  }
  .rl-six__head {
    padding: 48px 20px 0;
    margin-bottom: 24px;
  }
  .rl-six__title {
    font-size: 32px;
  }
  .rl-six__grid {
    width: 100%;
    height: auto;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 10px;
    row-gap: 10px;
  }
  .rl-six__card {
    width: auto;
    height: auto;
    min-height: 280px;
    padding: 28px 14px 24px;
  }
  .rl-six__card-desc {
    text-align: center;
  }
  .rl-enterprise__title {
    font-size: 32px;
    margin-bottom: 40px;
  }
  .rl-enterprise {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
  }
  .rl-enterprise__panel {
    width: 100%;
    height: auto;
    min-height: 480px;
  }
  .rl-enterprise__panel-inner {
    padding: 0 24px 40px;
  }
  .rl-enterprise__icon {
    margin-top: 200px;
    margin-bottom: 48px;
  }
  .rl-enterprise__panel-title {
    font-size: 28px;
    margin-bottom: 32px;
  }
  .rl-enterprise__panel-desc {
    font-size: 20px;
  }
  .rl-section--guardian {
    height: auto;
    min-height: 480px;
  }
  .rl-guardian__inner {
    padding: 0 20px;
  }
  .rl-guardian__watermark {
    margin-bottom: 16px;
    max-width: 100%;
  }
  .rl-guardian__title {
    font-size: 32px;
    margin-bottom: 20px;
  }
  .rl-guardian__desc {
    font-size: 18px;
    margin-bottom: 28px;
  }
  .rl-platform {
    grid-template-columns: 1fr;
  }
  .rl-h2 {
    font-size: 32px;
  }
  .rl-travel__inner {
    padding: 56px 20px;
  }
  .rl-travel__title {
    font-size: 36px;
  }
  .rl-travel__desc {
    font-size: 16px;
    line-height: 1.75;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/rescueList/rescueList.vue